import { create } from 'zustand';

interface State {
  fbclid: string | null;
  fbp: string | null;
  setAnalyticsTokens: ({
    fbclid,
    fbp
  }: {
    fbclid: string;
    fbp: string;
  }) => void;
}

const useFacebookAnalyticsStore = create<State>((set) => ({
  setAnalyticsTokens: async ({ fbclid, fbp }) => {
    set({ fbclid, fbp });
  },
  fbclid: null,
  fbp: null
}));

export default useFacebookAnalyticsStore;
